import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ACTIVATION_ERRORS, ERRORS, NOTIFICATION_KEYWORDS, REGEX, ROUTES } from "src/app/constants";
import { AuthService } from "src/app/services/auth.service";
import { I18nService } from "src/app/services/i18n.service";
import { NotificationService } from "src/app/services/notification.service";
import { UtilityService } from "src/app/services/utility.service";

@Component( {
	selector: "app-invitation",
	templateUrl: "./invitation.component.html",
	styleUrls: [ "./invitation.component.scss" ]
} )
export class InvitationComponent implements OnInit {
	invitation: FormGroup;
	invitationForNewUser: FormGroup;
	termsAndConditionsUrl: string;
	privacyPolicyUrl: string;
	isExist: string;
	isConfirmMatch: boolean;
	isConfirmMatchForNewUser: boolean
	queryParams: any;
	organizationId: string;
	email: string;
	organizationName: string;
	passwordVisible = false;
	confirmPasswordVisible = false;
	userType: string;

	constructor(
		private formBuilder: FormBuilder,
		private i18nService: I18nService,
		private activatedRoute: ActivatedRoute,
		private utilityService: UtilityService,
		private authService: AuthService,
		private notificationService: NotificationService,
		private spinnerService: NgxSpinnerService
	) {
		const urls = this.i18nService.getPrivacyPolicyAndTermsAndConditionsUrl();
		this.termsAndConditionsUrl = urls["termsAndConditions"];
		this.privacyPolicyUrl = urls["privacyPolicy"];

		this.activatedRoute.queryParams.subscribe((params) => {
			this.isExist = params["isExist"];
			this.organizationId = params["organizationId"];
			this.email = params["email"];
			this.organizationName = params["organizationName"];
			this.userType = params["type"];
		});
	}

	ngOnInit(): void {
		this.newUserInvitationForm();
		this.existingUserInvitationForm();

		this.invitation.valueChanges.subscribe( ( value ) => {
			const passwordRegex = REGEX.PASSWORD;
			const digitsRegex = REGEX.DIGITS;
			const specialCharacterRegex = REGEX.SPECIAL_CHARACTERS;
			const uppercaseRegex = REGEX.UPPERCASE_LETTERS;
			const spaceRegex = REGEX.SPACES;
			const lowercaseRegex = REGEX.LOWERCASE_LETTERS;

			if ( value.password && !value.password.match( passwordRegex ) ) {
				if ( value.password && !value.password.match( specialCharacterRegex ) ) {
					this.invitation.controls["password"].setErrors( { "specialCharacterRequired": true } );
				}

				if ( value.password && !value.password.match( uppercaseRegex ) ) {
					this.invitation.controls["password"].setErrors( { "uppercaseRequired": true } );
				}

				if ( value.password && !value.password.match( digitsRegex ) ) {
					this.invitation.controls["password"].setErrors( { "digitRequired": true } );
				}

				if ( value.password && value.password.match( spaceRegex ) ) {
					this.invitation.controls["password"].setErrors( { "spaceInvalid": true } );
				}

				if ( value.password && !value.password.match( lowercaseRegex ) ) {
					this.invitation.controls["password"].setErrors( { "lowercaseRequired": true } );
				}
			}

			if ( value.password && value.confirmPassword && ( value.password !== value.confirmPassword ) ) {
				this.isConfirmMatch = false;
				this.invitation.controls["confirmPassword"].setErrors( { "incorrect": true } );
			}
			this.isConfirmMatch = true;
		} );

		this.invitationForNewUser.valueChanges.subscribe( ( value ) => {
			const passwordRegex = REGEX.PASSWORD;
			const emailRegex = REGEX.EMAIL;
			const nameRegex = REGEX.NAME;
			const digitsRegex = REGEX.DIGITS;
			const specialCharacterRegex = REGEX.SPECIAL_CHARACTERS;
			const uppercaseRegex = REGEX.UPPERCASE_LETTERS;
			const spaceRegex = REGEX.SPACES;
			const lowercaseRegex = REGEX.LOWERCASE_LETTERS;
			const usernameRegex = REGEX.USERNAME;
			const specialCharacterWithoutSpaceAndHyphen = REGEX.SPECIAL_CHARACTERS_WITHOUT_SPACE_HYPHEN;

			if ( value?.firstName?.trim() && !value?.firstName?.trim().match( usernameRegex ) ) {
				if ( value?.firstName && value?.firstName?.trim().match( digitsRegex ) ) {
					this.invitationForNewUser.controls["firstName"].setErrors( { "digitsNotAllowed": true } );
				} else if( value?.firstName && value?.firstName?.trim().match( specialCharacterWithoutSpaceAndHyphen ) ) {
					this.invitationForNewUser.controls["firstName"].setErrors( { "invalidSpecialCharacter" : true } );
				} else {
					this.invitationForNewUser.controls["firstName"].setErrors( { "invalidFirstName": true } );
				}
			}

			if ( value?.lastName?.trim() && !value?.lastName?.trim().match( usernameRegex ) ) {
				if ( value?.lastName && value?.lastName?.trim().match( digitsRegex ) ) {
					this.invitationForNewUser.controls["lastName"].setErrors( { "digitsNotAllowed": true } );
				} else if( value?.lastName && value?.lastName?.trim().match( specialCharacterWithoutSpaceAndHyphen ) ) {
					this.invitationForNewUser.controls["lastName"].setErrors( { "invalidSpecialCharacter" : true } );
				} else {
					this.invitationForNewUser.controls["lastName"].setErrors( { "invalidLastName": true } );
				}
			}

			if ( value.email && value.email.endsWith( "@" ) ) {
				this.invitationForNewUser.controls["email"].setErrors( { "incompleteEmail": true } );
			} else if ( value.email && !value.email.match( emailRegex ) ) {
				this.invitationForNewUser.controls["email"].setErrors( { "invalidEmail": true } );
			}

			if ( value.password && !value.password.match( passwordRegex ) ) {
				if ( value.password && !value.password.match( specialCharacterRegex ) ) {
					this.invitationForNewUser.controls["password"].setErrors( { "specialCharacterRequired": true } );
				}

				if ( value.password && !value.password.match( uppercaseRegex ) ) {
					this.invitationForNewUser.controls["password"].setErrors( { "uppercaseRequired": true } );
				}

				if ( value.password && !value.password.match( digitsRegex ) ) {
					this.invitationForNewUser.controls["password"].setErrors( { "digitRequired": true } );
				}

				if ( value.password && value.password.match( spaceRegex ) ) {
					this.invitationForNewUser.controls["password"].setErrors( { "spaceInvalid": true } );
				}

				if ( value.password && !value.password.match( lowercaseRegex ) ) {
					this.invitationForNewUser.controls["password"].setErrors( { "lowercaseRequired": true } );
				}
			}

			if ( value.password && value.confirmPassword && ( value.password !== value.confirmPassword ) ) {
				this.isConfirmMatchForNewUser = false;
				this.invitationForNewUser.controls["confirmPassword"].setErrors( { "incorrect": true } );
			}
			this.isConfirmMatchForNewUser = true;
		} );
	}

	/**
	 * newly invited user form
	 */
	newUserInvitationForm() {
		this.invitationForNewUser = this.formBuilder.group( {
			firstName: [ "" ],
			lastName: [ "" ],
			password: [ null, [ Validators.required, Validators.minLength( 8 ) ] ],
			confirmPassword: [ null, [ Validators.required ] ]
		} );
	}

	/**
	 * Existing user invitation form
	 */
	existingUserInvitationForm() {
		this.invitation = this.formBuilder.group( {
			password: [ null, [ Validators.required, Validators.minLength( 8 ) ] ],
			confirmPassword: [ "", [ Validators.required ] ]
		} );
	}

	/**
	 * Accept invitation form for new user
	 */
	acceptInvitationForNewUser() {
		this.spinnerService.show();
		const data = {
			firstName: this.invitationForNewUser.value.firstName,
			lastName: this.invitationForNewUser.value.lastName,
			password: this.invitationForNewUser.value.password,
			confirmPassword: this.invitationForNewUser.value.confirmPassword,
			email: this.email,
			id: this.organizationId

		};
		this.authService.invitationForNewUser( data ).subscribe( ( response ) => {
			if ( response ) {
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.INVITATION_ACCEPT );
			}
			this.spinnerService.hide();
			this.utilityService.navigate( ROUTES.LOG_IN );
		}, ( error ) => {
			this.spinnerService.hide();
			if( error?.error === ACTIVATION_ERRORS.ALREADY_ADDED ){
				this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.ALREADY_ACCEPTED );
				return;
			}
			this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.TRY_AGAIN );
			if(this.email){
				error.email = this.email;
			}
		} );
	}

	/**
	 * Accept invitation form for existing user
	 */
	acceptInvitationForExistingUser() {
		const data = {
			email: this.email,
			password: this.invitation.value.password,
			confirmPassword: this.invitation.value.confirmPassword,
			id: this.organizationId
		};
		this.spinnerService.show();
		this.authService.invitationForNewUser( data ).subscribe( ( response ) => {
			if ( response ) {
				this.spinnerService.hide();
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.INVITATION_ACCEPT );
			}
			this.utilityService.navigate( ROUTES.LOG_IN );
		}, ( error ) => {
			this.spinnerService.hide();
			if( error?.error === ACTIVATION_ERRORS.ALREADY_ADDED ){
				this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.ALREADY_ACCEPTED );
				return;
			}
			this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.TRY_AGAIN );
		} );
	}

	/**
	 * Accept invitation for existing supplier user
	 */
	acceptInvitationForExistingSupplierUser() {
		const data = {
			email: this.email,
			password: this.invitation.value.password,
			confirmPassword: this.invitation.value.confirmPassword,
			id: this.organizationId
		};
		this.spinnerService.show();
		this.authService.invitationForSupplierUser( data ).subscribe( ( response ) => {
			if ( response ) {
				this.spinnerService.hide();
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.INVITATION_ACCEPT );
			}
			this.utilityService.navigate( ROUTES.LOG_IN );
		}, ( error ) => {
			this.spinnerService.hide();
			if( error?.error === ACTIVATION_ERRORS.ALREADY_ADDED ){
				this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.ALREADY_ACCEPTED );
				return;
			}
			this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.TRY_AGAIN );
		} );
	}

	/**
	 * Accept invitation for existing supplier user
	 */
	acceptInvitationForNewSupplierUser() {
		this.spinnerService.show();
		const data = {
			firstName: this.invitationForNewUser.value.firstName,
			lastName: this.invitationForNewUser.value.lastName,
			password: this.invitationForNewUser.value.password,
			confirmPassword: this.invitationForNewUser.value.confirmPassword,
			id: this.organizationId,
			email: this.email
		};
		this.authService.invitationForSupplierUser( data ).subscribe( ( response ) => {
			this.spinnerService.hide();
			if ( response ) {
				this.notificationService.successNotification( NOTIFICATION_KEYWORDS.INVITATION_ACCEPT );
			}
			this.utilityService.navigate( ROUTES.LOG_IN );
		}, ( error ) => {
			this.spinnerService.hide();
			if( error?.error === ACTIVATION_ERRORS.ALREADY_ADDED ){
				this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.ALREADY_ACCEPTED );
				return;
			}
			this.notificationService.failureNotification( NOTIFICATION_KEYWORDS.TRY_AGAIN );
		} );
	}

}
